'use client';

import { QuestionAnswerList } from '@ninjacart/nc-nk-advisory';
import { ReportFastContextProvider } from '@ninjacart/nc-nk-store';
import { ReportBottomSheet, YStack } from '@ninjacart/nc-nk-ui';

export function QuestionAnswerLayout() {
  return (
    <YStack fullscreen flexDirection="row" bg="$background">
      <YStack flex={1}>
          <ReportFastContextProvider>
            <QuestionAnswerList />
            <ReportBottomSheet />
          </ReportFastContextProvider>
      </YStack>
    </YStack>
  );
}
